module.exports = __webpack_public_path__ + "static/media/About.202c3da2.md";